// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"53bbbb56044715710097","966":"e8e4f916dcc9dd4b7920"}[chunkId] + ".js";
};